export default __webpack_public_path__ + "static/media/raffle.7fed7116.jpg";